export enum AppointmentStateKeys {
  BroadbandInstallationAppointment = 'BROADBAND_INSTALLATION_APPOINTMENT',
  BroadbandChangeAppointmentModalOpen = 'BROADBAND_CHANGE_APPOINTMENT_MODAL_OPEN',
  BroadbandChangeAppointmentErrorModalOpen = 'BROADBAND_CHANGE_APPOINTMENT_ERROR_MODAL_OPEN',
  BroadbandModalTentativeAppointment = 'BROADBAND_MODAL_TENTATIVE_APPOINTMENT',
  BroadbandDatePickerOpen = 'BROADBAND_DATE_PICKER_OPEN',
  BroadbandDatePickerViewedDate = 'BROADBAND_DATE_PICKER_VIEWED_DATE',
  BroadbandDatePickerSelectedDate = 'BROADBAND_DATE_PICKER_SELECTED_DATE',
}
